import getIPC from 'node-ipc-promise';

const ipc = getIPC();

export function send(message: string, ...args: Array<any>): Promise<any> {
  return ipc.exec(message, ...args);
}

export const on = (eventName, callback) => ipc.register(eventName, callback);
